"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var _1 = require("./");
var icon_1 = require("../icon");
var MenuTree = /** @class */ (function (_super) {
    tslib_1.__extends(MenuTree, _super);
    function MenuTree(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setRef = function (el) {
            _this.el = el;
        };
        _this.state = { lastVisibleItemIndex: null };
        _this.el = null;
        _this.originalWidths = [];
        _this.totalWidth = 0;
        _this.calcMoreItems = _this.calcMoreItems.bind(_this);
        return _this;
    }
    MenuTree.prototype.getChildContext = function () {
        return {
            onMenuItemClick: this.props.onItemClick
        };
    };
    MenuTree.prototype.componentDidMount = function () {
        var $list = this.el.querySelector("ul");
        if ($list) {
            var items = utils_1.nodeListToArrayOf($list.children);
            this.originalWidths = items.map(function (child) { return child.getBoundingClientRect().width; });
            this.totalWidth = this.originalWidths.reduce(function (r, c) { return r + c; }, 0);
            this.calcMoreItems();
        }
        window.addEventListener("resize", this.calcMoreItems, false);
    };
    MenuTree.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.calcMoreItems, false);
    };
    MenuTree.prototype.calcMoreItems = function () {
        var _this = this;
        utils_1.raf(function () {
            var lastVisibleItemIndex = _this.state.lastVisibleItemIndex;
            _this.el.style.overflow = "hidden";
            var innerWidth = _this.el.getBoundingClientRect().width;
            _this.el.style.overflow = "";
            if (innerWidth > _this.totalWidth) {
                if (lastVisibleItemIndex !== null) {
                    _this.setState({ lastVisibleItemIndex: null });
                }
                return;
            }
            var calc = 0;
            var lastVisible = null;
            for (var i = 0, len = _this.originalWidths.length; i < len; i++) {
                calc += _this.originalWidths[i];
                if (calc + 64 > innerWidth) {
                    lastVisible = i;
                    break;
                }
            }
            if (lastVisibleItemIndex !== lastVisible) {
                if (!isNaN(lastVisible) && lastVisible < 0) {
                    lastVisible = 0;
                }
                _this.setState({ lastVisibleItemIndex: lastVisible });
            }
        });
    };
    MenuTree.prototype.render = function () {
        var _a = this.props, className = _a.className, theme = _a.theme;
        var lastVisibleItemIndex = this.state.lastVisibleItemIndex;
        var classes = classnames_1.default(theme["menu-tree"], className);
        var items = this.props.items;
        if (lastVisibleItemIndex !== null) {
            items = items.slice(0, lastVisibleItemIndex).concat({
                title: React.createElement(icon_1.Icon, { size: 4.8, iconName: "icon-more" }),
                rootAggregator: true,
                items: items.slice(lastVisibleItemIndex)
            });
        }
        return (React.createElement("div", { className: classes, ref: this.setRef },
            React.createElement(_1.MenuSubTree, { items: items, level: 0 })));
    };
    MenuTree.defaultProps = {
        onItemClick: utils_1.noop
    };
    MenuTree.childContextTypes = {
        onMenuItemClick: PropTypes.func
    };
    return MenuTree;
}(React.Component));
exports.default = MenuTree;
